import { Control } from "../../business-objects/control/control.model";
import { ComplexControlConfig } from "./complex-control-config.model";

export class ComplexControl extends Control {
    config: ComplexControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/complex/complex-control.model.ts